import opModalContainer from './modalsContainer.vue';
import { ModalBus } from './modalBus';

export default {
    install (app, options = {}) {
        if (this.installed) {
            return
        }

        app.component('OpModalContainer', opModalContainer);
        this.installed = true
        
        app.config.globalProperties.$opModal = {
            modals: ModalBus.getModals,
            show (modal, props, closeCallback = null) {
                ModalBus.addModal(modal, props, closeCallback);
            },
            closeAll() {
                ModalBus.closeAllModals();
            },
            closeLast() {
                ModalBus.closeLastModal();
            }
        }
    }
}